import React from "react";
import { motion } from "framer-motion";
import GetInTouchtwo from "./Section/GetinTouchtwo";
import { Helmet } from "react-helmet-async";

function Contactus() {
  return (
    <div className="mt-2 bg-[#0C2341] px-4 min-h-screen flex justify-center items-center">
      <Helmet>
        <title>AKT : Contact Us</title>

        <meta name="description" content="AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client's business needs. AKT Corp recognizes the need to support clients with high-quality products and marketing support." />

        <meta name="keywords" content="AKT Corp, Arabian Karim Trading Co. LLC, AKT Trading, AKT Corporation, Industrial Solutions, Industrial Equipment Suppliers, Building Materials Supplier, Offshore Industry Supplies, Oil & Gas Industry Supplies, Steel Solutions Supplier, Fiber Optics Solutions, Advanced Silicone Products, Industrial Lubricants Supplier, Fire-Rated Components, Thermal Insulation Solutions, Heavy Equipment Supplies, Electronics Industry Materials, Personal Care & Healthcare Solutions, Saudi Aramco Supplier, MARAFIQ Industrial Solutions, Saudi Arabia Railways Co Supplies, Petro Rabigh Industrial Products, Herkula Partner, Livesmart Partner, Momentive Products Supplier, Fenzi Industrial Solutions, Reliable Industrial Supplies, High-Quality Industrial Equipment, Heavy Machinery Lubricants, Advanced Sealing & Adhesives, Manufacturing Materials Supplier, Construction Materials Supplier, Electrical Components Supplier, Industrial Chemicals & Coatings, Request a Quote AKT Corp, Industrial Supplier in Saudi Arabia, Contact AKT Corp, Buy Industrial Materials Online, Fast & Reliable Industrial Supplies, Customized Industrial Solutions" />
      </Helmet>
      <motion.div
        initial={{ opacity: 0, y: 80 }} // Starts below
        whileInView={{ opacity: 1, y: 0 }} // Moves up smoothly
        transition={{ duration: 0.6, delay: 0.3 }} // Adds delay
        viewport={{ once: true }} // Only animates once
      >
        <GetInTouchtwo />
      </motion.div>
    </div>
  );
}

export default Contactus;
